/**
 * Rounds a number up to the smallest multiple of 10 that is greater than or equal to it.
 *
 * - Exact multiples of 10 are returned unchanged.
 *
 * Examples:
 * ceilToMultipleOfTen(1)   // 10
 * ceilToMultipleOfTen(10)  // 10
 * ceilToMultipleOfTen(11)  // 20
 */
export function ceilToMultipleOfTen(value: number): number {
  return Math.ceil(value / 10) * 10;
}
